export interface ApiError {
  title: string; // Short, human-readable summary of the problem.
  detail?: string; // Human-readable explanation specific to this occurence of the problem.
  field?: string; // Reference to the source of the error.
  meta?: any; // Any other non-standard data.
}

// Fallback messages, in the user's language
export interface ErrorMessages {
  somethingWentWrong: string;
  serverError: string;
  invalidValue: string;
}

export const getResponseErrors = (
  errors: ApiError[] | undefined,
  messages: ErrorMessages,
): [string[], { [key: string]: string }] => {
  const fieldErrors: { [key: string]: string } = {}
  const generalErrors: string[] = []

  if (!errors || errors.length === 0) {
    return [[messages.somethingWentWrong], fieldErrors];
  }

  errors.forEach((error) => {
    if (error.field) {
      // The title only names the field ("Error in password"); the detail says what is wrong
      fieldErrors[error.field] = error.detail || error.title || messages.invalidValue
    } else {
      // Provide user-friendly messages for common errors
      let message = error.title || messages.somethingWentWrong;

      // Improve internal server error messages
      if (message === "Internal Server Error") {
        message = messages.serverError;
      }

      generalErrors.push(message);
    }
  });

  return [generalErrors, fieldErrors]
};


// The interface that the server will respond with
export interface ResponseData<T> {
  data?: T;
  errors?: ApiError[];
}

// Interface returned from client.ts
export interface ApiResponse<T> {
  status?: number;
  data?: T;
  errors?: ApiError[];
  success: boolean
}
